import { useEffect } from "react";

const DEFAULT_TITLE = "CLYMACO | Consulting + SaaS for EPR, Waste & Circular Economy";
const DEFAULT_DESCRIPTION = "CLYMACO combines specialist consulting and proprietary client SaaS for India and global EPR, solid waste management, bulk waste generators, circular economy and waste-focused CSR.";

function setMeta(selector, attr, value) {
  let tag = document.head.querySelector(selector);
  if (!tag) {
    tag = document.createElement("meta");
    if (selector.includes('property="og:')) tag.setAttribute("property", selector.match(/property="([^"]+)"/)[1]);
    else tag.setAttribute("name", selector.match(/name="([^"]+)"/)[1]);
    document.head.appendChild(tag);
  }
  tag.setAttribute("content", value);
  return tag;
}

export function useSeo({ title, description, path = "/", image = "https://clymaco.com/sample-assets/00-editorial-still-life-of-recovered-metals-recycled-plastic-paper-and-electronic-components-on-a-green-surface.webp" }) {
  useEffect(() => {
    const fullTitle = title ? `${title} | CLYMACO` : DEFAULT_TITLE;
    const desc = description || DEFAULT_DESCRIPTION;
    const url = `https://clymaco.com${path}`;
    document.title = fullTitle;
    setMeta('meta[name="description"]', "content", desc);
    setMeta('meta[property="og:title"]', "content", fullTitle);
    setMeta('meta[property="og:description"]', "content", desc);
    setMeta('meta[property="og:url"]', "content", url);
    setMeta('meta[property="og:image"]', "content", image);
    let canonical = document.head.querySelector('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.setAttribute("rel", "canonical");
      document.head.appendChild(canonical);
    }
    canonical.setAttribute("href", url);
    return () => {
      document.title = DEFAULT_TITLE;
      setMeta('meta[name="description"]', "content", DEFAULT_DESCRIPTION);
      canonical.setAttribute("href", "https://clymaco.com/");
    };
  }, [title, description, path, image]);
}

export function JsonLd({ data, id }) {
  useEffect(() => {
    const tag = document.createElement("script");
    tag.type = "application/ld+json";
    tag.id = id;
    tag.text = JSON.stringify(data);
    document.head.appendChild(tag);
    return () => tag.remove();
  }, [data, id]);
  return null;
}
